import isNumber from "lodash/isNumber";

const IN_PER_METER = 39.3701;
const IN_PER_FT = 12;
const CM_PER_INCH = 2.54;
const CM_PER_METER = 100;

export const UNIT_CM = "cm";
export const UNIT_M = "m";
export const UNIT_IN = "in";

export const cmToMeter = cm => cm / CM_PER_METER;
export const cmToInch = cm => cm / CM_PER_INCH;

export const meterToInch = m => m * IN_PER_METER;
export const meterToCm = m => m * CM_PER_METER;

export const inchToMeter = inch => inch / IN_PER_METER;
export const inchToCm = inch => inch * CM_PER_INCH;

export const ftToInch = feet => feet * IN_PER_FT;

export const feetInchesToInches = (inches, feet) => {
  if (!isNumber(inches) && !isNumber(feet)) {
    return null;
  }
  return inches + ftToInch(feet);
};

export const inchesToFeetInches = totalInches => {
  if (!totalInches && totalInches !== 0) {
    return { inches: null, feet: null };
  }
  let feet = Math.floor(totalInches / 12);
  let inches = parseFloat((totalInches % 12).toFixed(1));
  inches = Math.round(inches);

  if (inches === 12) {
    inches = 0;
    feet++;
  }

  return { inches, feet };
};

export const ALLOWED_UNITS = [UNIT_CM, UNIT_M, UNIT_IN];

const conversionMap = {
  [UNIT_CM]: {
    [UNIT_M]: cmToMeter,
    [UNIT_IN]: cmToInch
  },
  [UNIT_M]: {
    [UNIT_IN]: meterToInch,
    [UNIT_CM]: meterToCm
  },
  [UNIT_IN]: {
    [UNIT_M]: inchToMeter,
    [UNIT_CM]: inchToCm
  }
};

export default function (amount, fromUnit, toUnit) {
  if (fromUnit === toUnit) {
    return amount;
  }
  try {
    return conversionMap[fromUnit][toUnit](amount);
  } catch {
    throw new Error(
      `Please provide a known measurement unit: ${ALLOWED_UNITS.join(
        ", "
      )} and value.`
    );
  }
}
